import { useDialog } from "@shared/features/dialog/useDialog";
import { usePlatform } from "@platform//PlatformContext";
import { useMobileMenu } from "@shared/features/mobileMenu/useMobileMenu";
import { useHandleNavigationClick } from "@shared/features/mobileMenu/useHandleNavigationClick";
import { DashboardNavigationItems } from "./DashboardNavigationItems";

export function DashboardNavigationItemsContainer() {
  const { closeMobileMenu } = useMobileMenu();

  const { user, isChatDisabled } = usePlatform();

  const { openDialog } = useDialog();

  const handleSearchClick = () => {
    closeMobileMenu();

    openDialog("supportSearch");
  };

  const { handleNavigationClick } = useHandleNavigationClick();

  return (
    <DashboardNavigationItems
      user={user}
      onOpenSearch={handleSearchClick}
      onNavigationClick={handleNavigationClick}
      isChatDisabled={isChatDisabled}
    />
  );
}

export default DashboardNavigationItemsContainer;
